import React from 'react'
import { Link } from 'react-router-dom';
import Slider from 'react-slick'


const PrevArrow = ({ className, onClick }) => (
    <div
        className={`${className} z-10 left-[30px] absolute top-[50%] transform -translate-y-1/2 cursor-pointer`}
        onClick={onClick}
    >
        <img src="/assets/service/previous.svg" alt="Previous" className="w-[60px] h-[60px]" />
    </div>
);

const NextArrow = ({ className, onClick }) => (
    <div
        className={`${className} z-10 right-[30px] absolute top-[50%] transform -translate-y-1/2 cursor-pointer`}
        onClick={onClick}
    >
        <img src="/assets/service/next.svg" alt="Next" className="w-[60px] h-[60px]" />
    </div>
);

function ServiceSlider() {
    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 4.3,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: true,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 4000,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };
    return (
       <>
  <Slider {...settings}>
    <Link to="/customised-enclosure-solutions">
      <div className="relative rounded-[10px] w-full max-w-[95%] h-[450px] group border border-gray-300 overflow-hidden">
        <img
          src="/assets/homeser1.png"
          className="w-full rounded-[10px]  h-full object-cover "
          alt="Trusted cable management and termination solutions provider in the UAE"
        />
        <div className="absolute inset-0 bg-black/0 transition-opacity duration-300 rounded-[10px]" />
        <div className="absolute bottom-0 w-full rounded-[10px] bg-[#01386A] px-[20px] py-[22px] opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <h6 className="font-[500] font-kanit text-[20px] leading-[30px] text-[#FFFFFF] text-center pb-[10px]">
            Customised Enclosure Solutions
          </h6>
          <p className="font-[300] font-kanit text-[16px] leading-[22px] text-center text-[#FFFFFF]">
          We provide tailor-made enclosure systems designed to meet your specific requirements. Every solution ensures durability, functionality, and ease of integration for your applications.
          </p>
        </div>
        <h6 className="absolute bg-black/30 bottom-0 left-1/2 -translate-x-1/2 font-[500] font-kanit text-[20px] leading-[30px] text-[#FFFFFF] text-center w-full opacity-100 group-hover:opacity-0 transition-opacity duration-300">
          Customised Enclosure Solutions
        </h6>
      </div>
    </Link>

    <Link to="/cable-termination">
      <div className="relative rounded-[10px] w-full max-w-[95%] h-[450px] group border border-gray-300 overflow-hidden">
        <img
          src="/assets/ig16.png"
          className="w-full h-full object-cover rounded-[10px]"
          alt="Trusted cable management and termination solutions provider in the UAE"
        />
        <div className="absolute inset-0 bg-black/0 transition-opacity duration-300 rounded-[10px]" />
        <div className="absolute bottom-0 w-full rounded-[10px] bg-[#01386A] px-[20px] py-[22px] opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <h6 className="font-[500] font-kanit text-[20px] leading-[30px] text-[#FFFFFF] text-center pb-[10px]">
            Cable Termination Support & Services
          </h6>
          <p className="font-[300] font-kanit text-[16px] leading-[22px] text-center text-[#FFFFFF]">
           Our factory-trained engineers offer expert guidance in cable preparation, terminal selection, and installation. We ensure full traceability and precision in every termination process.
          </p>
        </div>
        <h6 className="absolute bg-black/30 bottom-0 left-1/2 -translate-x-1/2 font-[500] font-kanit text-[20px] leading-[30px] text-[#FFFFFF] text-center w-full opacity-100 group-hover:opacity-0 transition-opacity duration-300">
          Cable Termination Support & Services
        </h6>
      </div>
    </Link>

    <Link to="/cable-industrial">
      <div className="relative rounded-[10px] w-full max-w-[95%] h-[450px] group border border-gray-300 overflow-hidden">
        <img
          src="/assets/homes2.png"
          className="w-full h-full object-cover rounded-[10px]"
          alt="Trusted cable management and termination solutions provider in the UAE"
        />
        <div className="absolute inset-0 bg-black/0 transition-opacity duration-300 rounded-[10px]" />
        <div className="absolute bottom-0 w-full rounded-[10px] bg-[#01386A] px-[20px] py-[22px] opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <h6 className="font-[500] font-kanit text-[20px] leading-[30px] text-[#FFFFFF] text-center pb-[10px]">
            Cable & Industrial Labelling
          </h6>
          <p className="font-[300] font-kanit text-[16px] leading-[22px] text-center text-[#FFFFFF]">
          We deliver professional labelling solutions for cables and wires, helping you identify connections easily. Our labels enhance safety, accuracy, and speed in maintenance and upgrades.


          </p>
        </div>
        <h6 className="absolute bg-black/30 bottom-0 left-1/2 -translate-x-1/2 font-[500] font-kanit text-[20px] leading-[30px] text-[#FFFFFF] text-center w-full opacity-100 group-hover:opacity-0 transition-opacity duration-300">
          Cable & Industrial Labelling
        </h6>
      </div>
    </Link>

    <Link to="/cable-cutting">
      <div className="relative rounded-[10px] w-full max-w-[95%] h-[450px] group border border-gray-300 overflow-hidden">
        <img
          src="/assets/homes3.png"
          className=" h-full  rounded-[10px]"
          alt="Trusted cable management and termination solutions provider in the UAE"
        />
        <div className="absolute inset-0 bg-black/0 transition-opacity duration-300 rounded-[10px]" />
        <div className="absolute bottom-0 w-full rounded-[10px] bg-[#01386A] px-[20px] py-[22px] opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <h6 className="font-[500] font-kanit text-[20px] leading-[30px] text-[#FFFFFF] text-center pb-[10px]">
           Cable Cutting, Harnessing, Labelling & Assemblies
          </h6>
          <p className="font-[300] font-kanit text-[16px] leading-[22px] text-center text-[#FFFFFF]">
           Our pre-cutting and labelling services provide neatly cut cables with precise tags. This ensures faster installation, improved organization, and reduced human error on-site.
          </p>
        </div>
        <h6 className="absolute bg-black/30 bottom-0 left-1/2 -translate-x-1/2 font-[500] font-kanit text-[20px] leading-[30px] text-[#FFFFFF] text-center w-full opacity-100 group-hover:opacity-0 transition-opacity duration-300">
          Cable Cutting, Harnessing, Labelling & Assemblies
        </h6>
      </div>
    </Link>

    <Link to="/transit-inspection">
      <div className="relative rounded-[10px] w-full max-w-[95%] h-[450px] group border border-gray-300 overflow-hidden bg-white">
        <img
          src="/assets/4.png"
          className="w-full h-full object-cover rounded-[10px]"
          alt="Trusted cable management and termination solutions provider in the UAE"
        />
        <div className="absolute inset-0 bg-black/0 transition-opacity duration-300 rounded-[10px]" />
        <div className="absolute bottom-0 w-full rounded-[10px] bg-[#01386A] px-[20px] py-[22px] opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <h6 className="font-[500] font-kanit text-[20px] leading-[30px] text-[#FFFFFF] text-center pb-[10px]">
            Transit - Inspection & Design
          </h6>
          <p className="font-[300] font-kanit text-[16px] leading-[22px] text-center text-[#FFFFFF]">
           We perform detailed site inspections of cable and pipe penetrations across industries. Our design support ensures secure sealing, safety, and long-term reliability in every project.
          </p>
        </div>
        <h6 className="absolute bg-black/30 bottom-0 left-1/2 -translate-x-1/2 font-[500] font-kanit text-[20px] leading-[30px] text-[#FFFFFF] text-center w-full opacity-100 group-hover:opacity-0 transition-opacity duration-300">
          Transit - Inspection & Design
        </h6>
      </div>
    </Link>
  </Slider>
</>

    )
}

export default ServiceSlider